import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DataMessage } from 'src/app/models/DataMessage';
import { DataOrder } from 'src/app/models/DataOrder';
import { Order } from 'src/app/models/Order';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { ResponseReportConfirm } from 'src/app/models/ResponseReportConfirm';
import { SearchReport } from 'src/app/models/SearchReport';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MessagesService } from 'src/app/services/messages.service';
import { OrderService } from 'src/app/services/order.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
declare var jQuery: any;

@Component({
  selector: 'app-confirm-orders',
  templateUrl: './confirm-orders.component.html',
  styleUrls: ['./confirm-orders.component.scss']
})
export class ConfirmOrdersComponent implements OnInit {

  public orders: Order[];
  titulos: String[] = ['CIP', 'PEDIDO', 'FECHA'];
  titlesModal: String[] = ['PRENDAS', 'CANTIDAD', 'TALLA', 'UMBRAL', 'STOCK', 'CINTA', 'EMPLEO', 'ARMA', 'ESTADO MAYOR',''];
  form: FormGroup;
  item: Order;
  dataOrder: DataOrder = new DataOrder();
  listOrders: Order[] = [];
  action: String;
  selectEdit: String;
  indexSelect: number = 0;
  public dataSource: ResponseReportConfirm[];
  public data: ResponseReportConfirm[];
  public dataSourceDetail: ResponseReportConfirm[];
  public displayedColumns: string[] = ['clothe', 'amount', 'stock', 'threshold', 'size', 'ribbon', 'job', 'weapon', 'generalStaff', 'confirm'];
  confirmMessage: DataMessage = new DataMessage();

  @ViewChild('orderDetailModal') orderDetailModal: ModalDirective;
  @ViewChild('confirmModal') confirmModal: ModalDirective;

  constructor(private mensajesService: MessagesService, private orderService: OrderService, private spinner: NgxSpinnerService, private toastr: ToastrService,
    private authService: AuthenticationService, private router: Router, private reportService: ReportService) { }

  ngOnInit() {
    this.spinner.show();
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      this.router.navigate(['login']);
    }
    this.loadOrders();

    this.form = new FormGroup({
      'cip': new FormControl('', Validators.required),
      'orderNumberBank': new FormControl('', Validators.required),
      'date': new FormControl('', Validators.required),
    });
  }

  loadOrders() {
    this.dataOrder.status = "";
    this.orderService.getOrdersToConfirm(this.dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          this.orders = data.orders;

          if (this.orders != null && this.orders != undefined) {
            for (let i = this.orders.length - 1; i >= 0; i--) {
              if (this.orders[i].status != "SAVED") {
                this.orders.splice(i, 1);
              }
            }
            // Ordenamos la lista por nombre
            this.orders.sort((a, b) => {
              if (a.orderNumberBank < b.orderNumberBank) {
                return -1;
              } else if (a.orderNumberBank > b.orderNumberBank) {
                return 1;
              } else {
                return 0;
              }
            });
            this.orders.forEach(order => {
              order.orderDetails.forEach(orderDetail => {
                // Ordenamos los precios por fecha
                orderDetail.clothes.prices.sort((a, b) => {
                  if (a.priceDate < b.priceDate) {
                    return -1;
                  } else if (a.priceDate > b.priceDate) {
                    return 1;
                  } else {
                    return 0;
                  }
                });
              });
            })
          } else {
            this.spinner.hide();
            this.toastr.info("NO EXISTEN PEDIDOS", "INFO");
          }
        }
        this.spinner.hide();
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  /**Metodo que rellena campos al seleccionar prenda */
  getItem() {
    let order: string = this.form.value["orderNumberBank"];
    this.orders.forEach(element => {
      if (element.orderNumberBank === order) {
        return this.item = element;
      }
    });
  }


  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  //Mostramos el detalle de las incidencias
  getOrderDetailModal() {

    this.orderDetailModal.show();
    let reportOrder = new ReportOrder();
    reportOrder.searchReport = new SearchReport();
    reportOrder.searchReport.orderId = this.item.id;

    for (let i = 0; i < this.item.orderDetails.length; i++) {
      reportOrder.searchReport.clothesId.push(this.item.orderDetails[i].clothes.id);
      reportOrder.searchReport.sizes.push(this.item.orderDetails[i].size);
    }

    this.reportService.getReportConfirm(reportOrder).subscribe(
      data => {
        if (getToken(data)) { 
          if (data.responseReportConfirm === null || data.responseReportConfirm.length === 0) {
            this.toastr.info("NO EXISTEN DATOS PARA MOSTRAR", "INFO");
          } else {

            this.dataSource = data.responseReportConfirm;

            for (let i = this.dataSource.length - 1; i >= 0; i--) {
              if (parseInt(this.dataSource[i].amount) <= parseInt(this.dataSource[i].maxAmount)) {
                this.dataSource.splice(i, 1);
              }
            }
          }
        }
        this.spinner.hide();
      }, error => {
        this.toastr.error(error);
        this.spinner.hide();
        this.logOut();
      }
    );

  }

  /**Método que se encarga de cerrar y liberar la memoria del modal*/
  closeDetailModal() {
    this.orderDetailModal.hide();
    this.orderDetailModal.ngOnDestroy();
  }

  /**Método que se encarga de cerrar y liberar la memoria del modal*/
  closeConfirmModal() {
    this.confirmModal.hide();
    this.confirmModal.ngOnDestroy();
  }

  /**Metodo que confirma el pedido con los detalles que quiera el usuario*/
  showConfirmModal() {
    this.confirmModal.show();
  }

  confirmOrder() {

    let index = this.item.orderDetails.length - 1;

    for (let i = index; i >= 0; i--) {
      for (let j = 0; j < this.item.orderDetails[i].clothes.nocSizes.length; j++) {
        if (this.item.orderDetails[i].clothes.nocSizes[j].size === this.item.orderDetails[i].size 
          && this.item.orderDetails[i].amount <= this.item.orderDetails[i].clothes.nocSizes[j].maxAmount
          && ((this.item.orderDetails[i].clothes.nocSizes[j].generalStaff===null && this.item.orderDetails[i].generalStaff===null) || this.item.orderDetails[i].clothes.nocSizes[j].generalStaff.description === this.item.orderDetails[i].generalStaff.description)
          && ((this.item.orderDetails[i].clothes.nocSizes[j].job===null && this.item.orderDetails[i].job===null) || this.item.orderDetails[i].clothes.nocSizes[j].job.description === this.item.orderDetails[i].job.description)
          && ((this.item.orderDetails[i].clothes.nocSizes[j].weapon===null && this.item.orderDetails[i].weapon===null) || this.item.orderDetails[i].clothes.nocSizes[j].weapon.description === this.item.orderDetails[i].weapon.description)
          && ((this.item.orderDetails[i].clothes.nocSizes[j].ribbon===null && this.item.orderDetails[i].ribbon===null) || this.item.orderDetails[i].clothes.nocSizes[j].ribbon.description === this.item.orderDetails[i].ribbon.description)) {
          this.item.orderDetails[i].isChecked = true;
        }
      }
      if (this.item.orderDetails[i].isChecked === false) {
        this.item.price -= this.item.orderDetails[i].clothes.prices[this.item.orderDetails[i].clothes.prices.length - 1].price * this.item.orderDetails[i].amount;
        this.item.orderDetails.splice(i, 1);
      }
    }

    let dataOrder: DataOrder = new DataOrder();
    if (this.item.orderDetails.length != 0) {
      this.item.status = 'CONFIRMED';
      this.item.confirmDate = new Date();
    }

    this.listOrders.push(this.item);
    dataOrder.orders = this.listOrders;
    dataOrder.nid = localStorage.getItem('nid');

    this.confirmMessage = {
      id: null,
      user: this.dataOrder.user,
      creationDate: null,
      nid: dataOrder.orders[0].user.nid,
      typeEffect: null,
      email: dataOrder.orders[0].user.email,
      question: "El pedido " + this.form.value["orderNumberBank"] + " ha sido confirmado dispone de dos horas para pagarlo.</br>" +
        +"Debera acceder a la aplicación PSP online de PCAMI, en la cesta usted podrá confirmar el pedido y realizar el pago.",

    }
    this.spinner.show();
    if (this.item.orderDetails.length == 0) {
      this.orderService.cancelOrders(dataOrder).subscribe(
        data => {
          if (getToken(data)) {
            localStorage.setItem("articulos", null);
            this.orderService.sendUpdate("0");
            this.orderService.changeTime(null);
            this.orderService.changeStatus(null);
            //this.orderService.currentArticles = new BehaviorSubject(null).asObservable();
            this.toastr.success("SE CANCELO EL PEDIDO CORRECTAMENTE", "INFO");
            this.confirmModal.hide();
            this.orderDetailModal.hide();
            this.router.navigate(['home']);
          }
        },
        error => {
          this.spinner.hide();
          this.confirmModal.hide();
          this.orderDetailModal.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
        }
      )
    } else {
        this.orderService.modifyOrder(dataOrder).subscribe(
          data => {
            if (getToken(data)) {
              this.toastr.success("SE MODIFICO EL PEDIDO CORRECTAMENTE", "INFO");
              this.sendMail();
              this.confirmModal.hide();
              this.orderDetailModal.hide();
              //this.router.navigate(['home']);
            }
          },
          error => {
            this.spinner.hide();
            this.confirmModal.hide();
            this.orderDetailModal.hide();
            this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
          }
        )
      }
  }

  togglecheck(e, clothes: string, size: string, ribbon: string, job: string, weapon: string, generalStaff:string) {

    let orderChecked = null;
    orderChecked = e.target.checked;

    for (let i = 0; i < this.item.orderDetails.length; i++) {
      if (this.item.orderDetails[i].clothes.name === clothes && this.item.orderDetails[i].size === size 
        && (this.item.orderDetails[i].ribbon===null || this.item.orderDetails[i].ribbon.description===ribbon)
        && (this.item.orderDetails[i].job===null || this.item.orderDetails[i].job.description===job)
        && (this.item.orderDetails[i].weapon===null || this.item.orderDetails[i].weapon.description===weapon)
        && (this.item.orderDetails[i].generalStaff===null || this.item.orderDetails[i].generalStaff.description===generalStaff)) {
        this.item.orderDetails[i].isChecked = orderChecked;
      }
    }
  }

  sendMail() {

    this.mensajesService.postConfirmOrder(this.confirmMessage).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success('EMAIL ENVIADO CORRECTAMENTE');
          this.router.navigate(['home']);
          this.spinner.hide();
        }
      },
      error => {
        this.toastr.error('EL EMAIL NO SE ENVIÓ CORRECTAMENTE');
        this.spinner.hide();
        this.router.navigate(['home']);
      })
  }

}
